import React from 'react';
import { withTranslation } from 'react-i18next'

const LogoutButton = ({click, t}) => {
    return (
        <span className="topbar__link" onClick={click}>
            <span className={`topbar__link-icon lnr lnr-exit`} />
            <p className="topbar__link-title">{t('topbar.logout')}</p>
        </span>
    )
}

export default  withTranslation('dashboard')(LogoutButton);
